const MAX_LETTER_BYTES = 5 * 1024 * 1024;

/** Why a picked file cannot be the letter, or null when it can. */
export function letterFileError(file) {
  const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
  if (!isPdf) return 'Upload the offer letter as a PDF.';
  if (file.size > MAX_LETTER_BYTES) return 'The letter is too large. The limit is 5 MB.';
  return null;
}
